import React from 'react';
import { Reviews } from '../../components';

/**
 * SellerReviews: displays all reviews for a seller (aggregated across listings).
 * Scrollable container so long review lists don't push the page.
 */
const SellerReviews = ({ reviews = [], fetchReviewsError }) => {
  if (fetchReviewsError) {
    return (
      <div className="bg-background border border-border rounded-xl p-4 sm:p-6 shadow-sm">
        <h3 className="font-heading font-bold uppercase text-lg mb-4">Seller Reviews</h3>
        <p className="text-sm text-destructive">Unable to load reviews.</p>
      </div>
    );
  }

  return (
    <div className="bg-background border border-border rounded-xl p-4 sm:p-6 shadow-sm">
      <h3 className="font-heading font-bold uppercase text-lg mb-4">
        Seller Reviews
        {reviews.length > 0 && (
          <span className="text-sm font-normal text-muted-foreground ml-2 normal-case">
            ({reviews.length})
          </span>
        )}
      </h3>
      {reviews.length > 0 ? (
        <div className="max-h-[600px] overflow-y-auto pr-1">
          <Reviews reviews={reviews} />
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">No reviews yet.</p>
      )}
    </div>
  );
};

export default SellerReviews;
